import React from "react";
import DataTable from "../../components/DataTable";

const dataJson = [
  {
    id: "01",
    txnid: "7sf4sfjdfjser",
    amount: "$4875",
    growth: "$548",
    remarks: "75",
    status: "Pending",
    date: "09/03/2022",
  },
  {
    id: "02",
    txnid: "f4d5dsfs",
    amount: "$4875",
    growth: "$548",
    remarks: "75",
    status: "Pending",
    date: "09/03/2022",
  },
  {
    id: "03",
    txnid: "74d8fd8f",
    amount: "$4875",
    growth: "$548",
    remarks: "75",
    status: "Pending",
    date: "09/03/2022",
  },
];

const columns = [
  { id: "id", label: "ID #", minWidth: 50 },
  { id: "txnid", label: "Txn ID", minWidth: 100 },
  {
    id: "amount",
    label: "Amount",
    minWidth: 100,
  },
  {
    id: "growth",
    label: "Growth",
    minWidth: 100,
  },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 100,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
  },
  {
    id: "date",
    label: "Date",
    minWidth: 100,
  },
];

function createData(id, txnid, amount, growth, remarks, status, date) {
  return { id, txnid, amount, growth, remarks, status, date };
}

const rows = dataJson.map((d) =>
  createData(d.id, d.txnid, d.amount, d.growth, d.remarks, d.status, d.date)
);

const MyTopupTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={10}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default MyTopupTable;
